import { Apartment } from "@boark/shared/types/apartment";
import { Link } from "react-router-dom";

import { formatApartment } from "../services/apartment";
import { recordIdToId } from "../utils/record-id-to-id";

export function ApartmentLink({
  apartment,
}: {
  apartment: Pick<
    Apartment,
    "id" | "index" | "streetNumber" | "apartmentNumber" | "objectNumber"
  >;
}) {
  return (
    <Link
      className="underline"
      to={`/admin/register/apartment/${recordIdToId(apartment.id)}`}
    >
      {formatApartment(apartment)}
    </Link>
  );
}
